<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" data-tour="lp-customization">
      <div class="col-lg-12">
        <form @submit.prevent="saveCustomization()" autocomplete="off">
          <div class="card">
            <div class="card-body">
              <b-tabs nav-class="nav-tabs-custom" content-class="p-3 text-muted" lazy>
                <b-tab active>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Imagens</span>
                  </template>
                  <h4 class="card-title mb-4">Upload de Imagens</h4>
                  <div class="row mb-4">
                    <div class="col-md-12">
                      <label class="d-block mb-2">Banner do Cabeçalho</label>
                      <input
                        ref="header_banner"
                        type="file"
                        accept="image/*"
                        @change="setImage($event, 'header_banner')"
                        style="display: none;"
                      />
                      <div class="border rounded p-3" style="background: #f8f9fa;">
                        <div v-if="customization.header_banner" class="text-center mb-2">
                          <img :src="customization.header_banner" class="img-fluid" style="max-height: 200px; border-radius: 8px;">
                        </div>
                        <div class="text-center">
                          <button type="button" class="btn btn-primary btn-sm mr-2" @click="$refs.header_banner.click()">
                            <i class="mdi mdi-upload"></i> {{ customization.header_banner ? 'Trocar' : 'Upload' }}
                          </button>
                          <button v-if="customization.header_banner" type="button" class="btn btn-danger btn-sm" @click="removeImage('header_banner')">
                            <i class="mdi mdi-delete"></i> Remover
                          </button>
                        </div>
                        <small class="text-muted d-block text-center mt-2">Recomendado: 1920x400px</small>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-4">
                    <div class="col-md-6">
                      <label class="d-block mb-2">Logo do Menu</label>
                      <input
                        ref="navbar_logo"
                        type="file"
                        accept="image/*"
                        @change="setImage($event, 'navbar_logo')"
                        style="display: none;"
                      />
                      <div class="border rounded p-3 text-center" style="background: #f8f9fa;">
                        <div v-if="customization.navbar_logo" class="mb-2">
                          <img :src="customization.navbar_logo" style="max-height: 80px;">
                        </div>
                        <div v-else class="mb-2">
                          <i class="mdi mdi-image-outline" style="font-size: 48px; color: #ced4da;"></i>
                        </div>
                        <button type="button" class="btn btn-primary btn-sm mr-2" @click="$refs.navbar_logo.click()">
                          <i class="mdi mdi-upload"></i> {{ customization.navbar_logo ? 'Trocar' : 'Upload' }}
                        </button>
                        <button v-if="customization.navbar_logo" type="button" class="btn btn-danger btn-sm" @click="removeImage('navbar_logo')">
                          <i class="mdi mdi-delete"></i> Remover
                        </button>
                        <small class="text-muted d-block mt-2">Recomendado: 200x60px</small>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label class="d-block mb-2">Favicon</label>
                      <input
                        ref="favicon"
                        type="file"
                        accept="image/*"
                        @change="setImage($event, 'favicon')"
                        style="display: none;"
                      />
                      <div class="border rounded p-3 text-center" style="background: #f8f9fa;">
                        <div v-if="customization.favicon" class="mb-2">
                          <img :src="customization.favicon" style="max-height: 80px;">
                        </div>
                        <div v-else class="mb-2">
                          <i class="mdi mdi-web" style="font-size: 48px; color: #ced4da;"></i>
                        </div>
                        <button type="button" class="btn btn-primary btn-sm mr-2" @click="$refs.favicon.click()">
                          <i class="mdi mdi-upload"></i> {{ customization.favicon ? 'Trocar' : 'Upload' }}
                        </button>
                        <button v-if="customization.favicon" type="button" class="btn btn-danger btn-sm" @click="removeImage('favicon')">
                          <i class="mdi mdi-delete"></i> Remover
                        </button>
                        <small class="text-muted d-block mt-2">Recomendado: 32x32px ou 64x64px</small>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="custom-control custom-switch">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="show_menu"
                          v-model="customization.show_menu"
                        />
                        <label class="custom-control-label" for="show_menu">
                          Exibir menu de navegação
                        </label>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    <span class="d-none d-sm-inline-block">Cores</span>
                  </template>
                  <h4 class="card-title mb-4">Cores do Site</h4>
                  <div class="row">
                    <div
                      class="col-md-4"
                      v-for="(field, key) in colorFields"
                      :key="key"
                    >
                      <div class="form-group">
                        <label>{{ field.label }}</label>
                        <input
                          type="color"
                          class="form-control"
                          v-model="customization[key]"
                          style="height: 50px;"
                        />
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    <span class="d-none d-sm-inline-block">Botões</span>
                  </template>
                  <h4 class="card-title mb-4">Textos dos Botões</h4>
                  <p class="text-muted mb-4">Personalize os textos dos botões exibidos na landing page.</p>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="navbar_button_label">Botão do Menu (Navbar)</label>
                        <input
                          id="navbar_button_label"
                          type="text"
                          class="form-control"
                          v-model="customization.navbar_button_label"
                          placeholder="Inscreva-se"
                        />
                        <small class="text-muted">Texto do botão no canto superior direito do site</small>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="form_button_label">Botão de Envio do Formulário</label>
                        <input
                          id="form_button_label"
                          type="text"
                          class="form-control"
                          v-model="customization.form_button_label"
                          placeholder="Enviar inscrição"
                        />
                        <small class="text-muted">Texto do botão de submissão do formulário de inscrição</small>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    <span class="d-none d-sm-inline-block">Sessões</span>
                  </template>
                  <h4 class="card-title mb-4">Ordem e Visibilidade das Sessões</h4>
                  <p class="text-muted mb-4">
                    Arraste para reordenar • Desmarque para ocultar a sessão
                  </p>
                  <draggable
                    v-model="customization.sections"
                    tag="div"
                    handle=".handle"
                    class="list-group"
                    @end="onDragEnd"
                  >
                    <div
                      v-for="(section, index) in customization.sections"
                      :key="section.id || section.key"
                      class="border rounded mb-3 p-4 bg-light"
                      style="box-shadow: 0 1px 3px rgba(0,0,0,0.1);"
                    >
                      <div class="d-flex align-items-start">
                        <div class="handle mr-3 text-muted flex-shrink-0 mt-1" style="cursor: move;">
                          <i class="mdi mdi-drag-vertical font-size-24"></i>
                        </div>
                        <div class="custom-control custom-switch mr-4 flex-shrink-0">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="'active_' + (section.id || section.key)"
                            v-model="section.active"
                            @change="updateSectionStatus(section)"
                          />
                          <label class="custom-control-label" :for="'active_' + (section.id || section.key)"></label>
                        </div>
                        <div class="flex-grow-1">
                          <div class="d-flex justify-content-between align-items-center mb-3">
                            <h5 class="mb-0 text-primary">{{ section.name }}</h5>
                            <small class="text-muted">Posição {{ index + 1 }}</small>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <div class="form-group mb-3">
                                <label class="font-weight-bold small text-muted">Título da seção</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="section.title"
                                  @blur="updateSectionStatus(section)"
                                  placeholder="Ex: Palestrantes, Programação, etc."
                                />
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="form-group">
                                <label class="font-weight-bold small text-muted">Subtítulo (opcional)</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="section.subtitle"
                                  @blur="updateSectionStatus(section)"
                                  placeholder="Ex: Conheça nossos especialistas"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </draggable>
                  <div class="alert alert-info mt-4">
                    <i class="mdi mdi-information-outline mr-2"></i>
                    As sessões desmarcadas não aparecerão no site. A ordem aqui define a sequência de exibição.
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <div class="float-right">
                <button type="submit" class="btn btn-primary mr-1">
                  <i class="mdi mdi-content-save"></i> Salvar Customização
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapState } from 'vuex'
import Swal from 'sweetalert2'
import draggable from 'vuedraggable'
import http from '@/http'

export default {
  name: 'CustomizationForm',
  components: {
    Layout,
    PageHeader,
    draggable
  },
  data () {
    return {
      title: 'Customização do Site',
      items: [
        { text: 'Site', href: '/' },
        { text: 'Customização', active: true }
      ],
      customization: {
        header_banner: '',
        navbar_logo: '',
        favicon: '',
        binaryHeaderBanner: null,
        binaryNavbarLogo: null,
        binaryFavicon: null,
        show_menu: true,
        navbar_bg_color: '#000000',
        navbar_text_color: '#ffffff',
        header_bg_color: '#000000',
        button_color: '#007bff',
        button_hover_color: '#0056b3',
        font_color: '#333333',
        section_title_color: '#000000',
        section_subtitle_color: '#666666',
        section_divider_color: '#e0e0e0',
        scrollbar_color: '#d1d5db',
        footer_bg_color: '#111827',
        footer_text_color: '#9ca3af',
        navbar_button_label: 'Inscreva-se',
        form_button_label: 'Enviar inscrição',
        sections: []
      },
      colorFields: {
        navbar_bg_color: { label: 'Cor da Navbar' },
        navbar_text_color: { label: 'Cor dos itens do menu' },
        header_bg_color: { label: 'Cor de Fundo do Cabeçalho' },
        button_color: { label: 'Cor dos Botões' },
        button_hover_color: { label: 'Cor dos Botões (Hover)' },
        font_color: { label: 'Cor da Fonte' },
        section_title_color: { label: 'Cor dos Títulos das Seções' },
        section_subtitle_color: { label: 'Cor dos Subtítulos' },
        section_divider_color: { label: 'Cor do Divisor' },
        scrollbar_color: { label: 'Cor da Barra de Rolagem' },
        footer_bg_color: { label: 'Cor de Fundo do Rodapé' },
        footer_text_color: { label: 'Cor do Texto do Rodapé' }
      }
    }
  },
  mounted () {
    this.loadCustomization()
  },
  computed: {
    ...mapState('customization', { data: 'customization' })
  },
  methods: {
    ...mapActions('customization', {
      fetch: 'GetCustomization',
      postData: 'SaveCustomization',
      deleteImg: 'DeleteImage'
    }),
    async loadCustomization () {
      const loader = this.$loading.show()
      try {
        await this.fetch()
        this.customization = { ...this.customization, ...this.data }
        const sectionsResponse = await http.get('/admin/sections')
        this.customization.sections = sectionsResponse.data || []
      } catch (e) {
        this.customization.sections = [
          { id: 1, key: 'speakers', name: 'Palestrantes', title: 'Palestrantes', subtitle: 'Conheça nossos especialistas', active: true },
          { id: 2, key: 'schedule', name: 'Programação', title: 'Programação', subtitle: 'Confira a agenda completa', active: true },
          { id: 3, key: 'sponsors', name: 'Patrocinadores', title: 'Patrocinadores', subtitle: 'Empresas que apoiam o evento', active: true },
          { id: 4, key: 'testimonials', name: 'Depoimentos', title: 'Depoimentos', subtitle: 'O que dizem sobre nós', active: true },
          { id: 5, key: 'photos', name: 'Galeria de Fotos', title: 'Galeria de Fotos', subtitle: 'Momentos especiais do evento', active: true },
          { id: 6, key: 'faqs', name: 'Perguntas Frequentes', title: 'Perguntas Frequentes', subtitle: 'Tire suas dúvidas', active: true }
        ]
      }
      loader.hide()
    },
    setImage (e, field) {
      const file = e.target.files[0]
      if (!file) return
      if (file.type.indexOf('image/') === -1) {
        errorMessage('Alerta: Por favor selecione uma imagem.')
        return
      }
      if (file.size / 1024 / 1024 > 2) {
        errorMessage('Alerta: Tamanho máximo 2MB!')
        return
      }
      if (field === 'header_banner') this.customization.binaryHeaderBanner = file
      if (field === 'navbar_logo') this.customization.binaryNavbarLogo = file
      if (field === 'favicon') this.customization.binaryFavicon = file
      const reader = new FileReader()
      reader.onload = (event) => {
        this.customization[field] = event.target.result
      }
      reader.readAsDataURL(file)
    },
    async removeImage (field) {
      const result = await Swal.fire({
        title: 'Remover imagem?',
        text: 'Esta ação não pode ser desfeita!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar'
      })
      if (result.isConfirmed) {
        const loader = this.$loading.show()
        try {
          await this.deleteImg(field)
          this.customization[field] = ''
          this.customization[`binary${field.charAt(0).toUpperCase() + field.slice(1)}`] = null
          successMessage('Imagem removida!')
        } catch (e) {
          errorMessage('Erro ao remover imagem')
        }
        loader.hide()
      }
    },
    async updateSectionStatus (section) {
      if (!section.id) return
      try {
        await http.put(`/admin/sections/${section.id}/status`, {
          is_active: section.active,
          title: section.title || '',
          subtitle: section.subtitle || ''
        })
      } catch (e) {
        section.active = !section.active
        errorMessage('Erro ao salvar seção')
      }
    },
    async onDragEnd () {
      try {
        const sectionIds = this.customization.sections
          .map(s => s.id)
          .filter(Boolean)
        if (sectionIds.length === 0) return
        await http.post('/admin/sections/reorder', {
          sections: sectionIds
        })
      } catch (e) {
        await this.loadCustomization()
        errorMessage('Erro ao reordenar seções')
      }
    },
    async saveCustomization () {
      const loader = this.$loading.show()
      try {
        const formData = new FormData()
        if (this.customization.binaryHeaderBanner) formData.append('header_banner', this.customization.binaryHeaderBanner)
        if (this.customization.binaryNavbarLogo) formData.append('navbar_logo', this.customization.binaryNavbarLogo)
        if (this.customization.binaryFavicon) formData.append('favicon', this.customization.binaryFavicon)
        formData.append('show_menu', this.customization.show_menu ? '1' : '0')
        formData.append('navbar_bg_color', this.customization.navbar_bg_color)
        formData.append('navbar_text_color', this.customization.navbar_text_color)
        formData.append('header_bg_color', this.customization.header_bg_color)
        formData.append('button_color', this.customization.button_color)
        formData.append('button_hover_color', this.customization.button_hover_color)
        formData.append('font_color', this.customization.font_color)
        formData.append('section_title_color', this.customization.section_title_color)
        formData.append('section_subtitle_color', this.customization.section_subtitle_color)
        formData.append('section_divider_color', this.customization.section_divider_color)
        formData.append('scrollbar_color', this.customization.scrollbar_color || '#d1d5db')
        formData.append('footer_bg_color', this.customization.footer_bg_color)
        formData.append('footer_text_color', this.customization.footer_text_color)
        formData.append('navbar_button_label', this.customization.navbar_button_label || 'Inscreva-se')
        formData.append('form_button_label', this.customization.form_button_label || 'Enviar inscrição')
        await this.postData(formData)
        successMessage('Customização salva com sucesso!', 2500)
        await this.loadCustomization()
      } catch (err) {
        errorMessage('Erro: ' + (err.message || 'Tente novamente'))
      } finally {
        loader.hide()
      }
    }
  }
}
</script>

<style scoped>
.handle {
  cursor: move;
}
.list-group-item {
  background: #f8f9fa;
}
</style>
